import React, { useEffect } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

const CustomRadio = ({
    value = null,
    onChange = () => null,
    operators = [{ key: 0, label: 'label', customKey: 'toAvoidCodeScanIssue' }],
    disabled = false,
    isRequired = false,
    forceErrorDisplay = false,
    isValidValue = (isValid) => null,
    returnTrueFalse = true,
    name,
    test,
    flexDirection = 'row',
}) => {
    useEffect(() => {
        if (value === null || value === undefined) {
            if (!isRequired) {
                isValidValue(true);
            } else {
                isValidValue(false);
            }
        } else {
            isValidValue(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, isRequired]);

    const checkValueExist = () => {
        if (value === null || value === undefined) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <>
            <RadioGroup
                name={name}
                value={value}
                onChange={onChange}
                style={{ flexWrap: 'nowrap', flexDirection: flexDirection }}
            >
                {operators.map((item) => {
                    return (
                        <FormControlLabel
                            style={{ paddingRight: 10 }}
                            key={item?.customKey ?? item.key}
                            value={item?.customKey ?? item.key}
                            control={<Radio disabled={disabled || item.disabled} size="small" color="primary" />}
                            label={item.label}
                        />
                    );
                })}
            </RadioGroup>
            {isRequired === true && forceErrorDisplay === true && !checkValueExist() && (
                <div style={{ color: 'red', fontSize: 12 }}>This field is required.</div>
            )}
        </>
    );
};

export default CustomRadio;
